export default function Footer() {
  return (
    <footer
      className="py-12 px-6 border-t border-linen bg-parchment-deep text-xs font-mono text-stone"
      data-testid="site-footer"
    >
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
        <div>SureLoom &mdash; Sovereign Enterprise AI Gateway</div>
        <div data-testid="footer-founder">Founder: George Bagley</div>
        <div>&copy; SureLoom Inc.</div>
      </div>
    </footer>
  );
}
